import { MultiValue } from "react-select";
import { previewProps } from "../atoms";
import { Address, CompaniesListReq, CorporateListRequest, MatchListReq, MessagesListReq, Pager, PaginatedRequest, StartupsListFiltersReq, StartupsListReq } from "./Api";
import { ConstitutionStatusOption, DTOStartup, DTOStartupById } from "./models";
import { Billing, Corporate, MatchDate, GeneralInfo, Filter, Message, Modal, OptionTypes, StartUp, User, UserInfo, Match, StartupAcceptedMatchType, ChatMessage, ModalChildrenPar, DatesResponse, Reasons, Option } from "./types";
import { Service } from "components/pagine";
import { Dispatch, SetStateAction } from "react";

export type StepperContextStartUpType = {
    // general
    plans: OptionTypes[];
    setPlans: (plans: OptionTypes[]) => void;
    sectors: OptionTypes[];
    setSectors: (sectors: OptionTypes[]) => void;
    constitutionStatuses: ConstitutionStatusOption[];
    setConstitutionStatuses: (plans: ConstitutionStatusOption[]) => void;
    generalInfo: GeneralInfo;
    setGeneralInfo: (generalInfo: GeneralInfo) => void;

    // user Info
    firstName: string;
    setFirstName: (name: string) => void;
    lastName: string;
    setLastName: (lastName: string) => void;
    email: string;
    setEmail: (email: string) => void;
    phoneNumber: string;
    setPhoneNumber: (phone: string) => void;
    password: string;
    setPassword: (password: string) => void;
    confirmPassword: string;
    setConfirmPassword: (confirmPassword: string) => void;

    //start Up Info
    startUpName: string;
    setStartUpName: (startUpName: string) => void;
    // website: string;
    // setWebSite: (webSite: string) => void;
    companyName: string;
    setCompanyName: (companyName: string) => void;
    vatNumber: string;
    setVatNumber: (vat: string) => void;
    address: Address | null;
    setAddress: (address: Address  | null) => void;
    country: string;
    setCountry: (address: string) => void;
    city: string;
    setCity: (address: string) => void;
    sdi: string;
    setSdi: (sdi: string) => void;
    pec: string;
    setPec: (pec: string) => void;
    state: ConstitutionStatusOption;
    setState: (option: ConstitutionStatusOption) => void;
    sector: OptionTypes;
    setSector: (option: OptionTypes) => void;

    // response
    selectedPlan: OptionTypes;
    setSelectedPlan: (option: OptionTypes) => void;
    termsChecked: boolean;
    setTermsChecked: (cheched: boolean) => void;
    privacyChecked: boolean;
    setPrivacyChecked: (cheched: boolean) => void
}

export type StepperContextCorporateType = {
    levels: OptionTypes[];
    setLevels: (_: OptionTypes[]) => void;
    departments: OptionTypes[];
    setDepartments: (_: OptionTypes[]) => void;

    // user Info
    linkedInId: string;
    setLinkedInId: (_: string) => void;
    firstName: string;
    setFirstName: (name: string) => void;
    lastName: string;
    setLastName: (lastName: string) => void;
    email: string;
    setEmail: (email: string) => void;
    sectors: MultiValue<OptionTypes>,
    setSectors: (sectorsId: MultiValue<OptionTypes> )=>void,
    reasons: MultiValue<OptionTypes>,
    setReasons: (reasons: MultiValue<OptionTypes>)=>void,
    reasonsDescription?: string,
    setReasonsDescription: (description:string | undefined)=>void,
    reasonsHasDescription?:boolean,
    setReasonsHasDescription:(hasDescription:boolean | undefined)=>void,
    password: string;
    setPassword: (password: string) => void;
    confirmPassword: string;
    setConfirmPassword: (confirmPassword: string) => void;
    guestID: string | undefined, 
    setGuestID: (id: string | undefined) => void,

    //Corporate Info
    companyName: string;
    setCompanyName: (companyName: string) => void;
    country: string;
    setCountry: (address: string) => void;
    city: string;
    setCity: (address: string) => void;
    cityOption: OptionTypes;
    setCityOption: (city: OptionTypes) => void;
    department: OptionTypes;
    setDepartment: (department: OptionTypes) => void;
    level: OptionTypes;
    setLevel: (level: OptionTypes) => void;
    jobTitle: string;
    setJobTitle: (vat: string) => void;
    termsChecked: boolean;
    setTermsChecked: (cheched: boolean) => void;
    privacyChecked: boolean;
    setPrivacyChecked: (cheched: boolean) => void
}
export enum LoginType {
    startup = 1,
    corporate = 2,
    guest = 3
}

export enum MatchStatus {
    //[Description("Startup started a match")]
    StartupStartedMatch = 1,
    //[Description("Company sent availability dates")]
    CompanySentAvailability = 2,
    //[Description("Startup selected a date, confirmed match")]
    StartupConfirmedMatch = 3,
    //[Description("Company started a match sending dates")]
    CompanyStartedMatch = 4,
    //[Description("Startup asked new availability dates")]
    StartupAskedNewAvailability = 5,
    //[Description("Company sent new availability dates")]
    CompanySentNewAvailability = 6,
    //[Description("Startup refused the match")]
    StartupRefusedMatch = -1,
    //[Description("Company refused the match")]
    CompanyRefusedMatch = -2
}

export type AppGeneralContextType = {
    baseUri?: string,
    loginType?: LoginType,
    setLoginType: (type: LoginType | undefined) => void,
    isForgotPassword:boolean,
    setIsForgotPassword:(par:boolean)=> void,
    isChooseNewPassword:boolean,
    setIsChooseNewPassword:(par:boolean)=> void,
    forgotPWNewEmail:string,
    setForgotPWNewEmail:(par:string)=> void,
    user?: User,
    setUser: (user: User | undefined) => void,
    userInfo: UserInfo;
    setUserInfo: (user: UserInfo) => void;
    menuIsOpen: boolean;
    setMenuIsOpen: (isOpen: boolean) => void;
    startUp: StartUp;
    setStartUp: (user: StartUp) => void;
    // Request of ask Match from startup to corporate
    numberMatchRequest: number,
    setNumberMatchRequest: (par: number) => void,
    //open chat
    chatIsOpen: boolean,
    setChatIsOpen: (chatIsOpen: boolean) => void

    // Corporate
    corporate: Corporate,
    setCorporate: (corporate: Corporate) => void

    //Corporates List
    corporatesList?: Corporate[],
    setCorporatesList: (corporates: Corporate[]) => void
    pagerCorporatesList: Pager,
    setPagerCorporatesList: (pager: Pager) => void
    reqCorporate: CompaniesListReq
    setReqCorporate: (req: CompaniesListReq) => void
    getCorporatesList: () => void
    isLoadingCorporates: boolean,
    setIsLoadingCorporates: (isLoading: boolean) => void,

    //Startup List
    startupsList: StartUp[],
    setStartupsList: (startups: StartUp[]) => void,
    pagerStartupsList: Pager,
    setPagerStartupsList: (pager: Pager) => void
    reqStartup: StartupsListReq,
    setReqStartup: Dispatch<SetStateAction<StartupsListReq>>,
    // setReqStartup: (req: StartupsListReq) => void,
    getStartupsList: (logged:boolean, req?:StartupsListFiltersReq) => void,
    isLoadingStartups: boolean,
    setIsLoadingStartups: (isLoading: boolean) => void,





    modalDatesIsOpen: boolean,
    setModalDatesIsOpen: (par: boolean) => void,
    dateResponse: DatesResponse,
    setDateResponse: (par: DatesResponse) => void,
    matchCallDates?: MatchDate[],
    setMatchCallDates: (par: MatchDate[]) => void,
    resetMatchCallDates: () => void,
    startUpIdforMatch: string,
    setstartUpIdforMatch: (startUpIdforMatch: string) => void,
    getUserData: (whoLogsIn: number) => Promise<boolean>,


    modal: Modal,
    setModal: (modal: Modal) => void,
    modalChildren: ModalChildrenPar,
    setModalChildren: (modal: ModalChildrenPar) => void,
    setLoadingModal: () => void,
    setErrorModal: (error?: string) => void,
    setClosedModal: () => void,

    loadingDepartmentOptions: boolean,
    setLoadingDepartmentOptions: (par: boolean) => void,
    departmentOptions: OptionTypes[],
    setDepartmentOptions: (par: OptionTypes[]) => void,
    getDepartmentsOptionsList: () => void,

    //levels
    loadingLevelsOptions: boolean,
    setLoadingLevelsOptions: (par: boolean) => void,
    levelsOptions: OptionTypes[],
    setLevelOptions: (par: OptionTypes[]) => void,
    getLevelOptionsList: () => void,

    //filter
    filter: Filter,
    setFilter: (filter: Filter) => void,
    loadingFilterOptions: boolean,
    setLoadingFilterOptions: (par: boolean) => void,
    getFilterOptionsList: (logged:boolean) => void,

    getStartupById: (id: string) => void,
    getStartupByIdGuest: (id: string) => void,
    IsLoadingGetStartupbyId: boolean,
    setIsLoadingGetStartupbyId: (isLoading: boolean) => void,
    startUpById: DTOStartupById,
    setStartUpById: (startUpById: DTOStartupById) => void,

    //match List
    isLoadingMatch: boolean,
    setIsLoadingMatch: (par: boolean) => void,
    matchList: Match[],
    setMatchList: (par: Match[]) => void,
    pagerMatchList: Pager,
    setPagerMatchList: (pager: Pager) => void,
    reqMatchList: MatchListReq,
    setReqMatchList: (par: MatchListReq) => void,
    getMatchList: () => void,

    //messages List
    matchSelected?: Match,
    setMatchSelected: (par: Match | undefined) => void,
    startupAcceptedMatch?: StartupAcceptedMatchType,
    setStartupAcceptedMatch: (par: StartupAcceptedMatchType | undefined) => void,
    isLoadingMessages: boolean,
    setIsLoadingMessages: (par: boolean) => void,
    messagesList: ChatMessage[],
    setMessagesList: (par: ChatMessage[]) => void,
    pagerMessagesList: Pager,
    setPagerMessagesList: (pager: Pager) => void,
    reqMessagesList: MessagesListReq,
    setReqMessagesList: (par: MessagesListReq) => void,
    getMessagesList: () => void,

    changePWisOpen: boolean,
    setchangePWisOpen: (par: boolean) => void,
  
    //Change Email
    resetEmailisOpen:boolean,
    setresetEmailisOPen:(par:boolean) => void,

    // Generate Code 
    generateVerifCodeisOpen:boolean,
    setGenerateCodeisOpen: (par: boolean) =>void,

    // Filter find a start up
    tags:OptionTypes | any , 
    setTags:(opt: MultiValue<OptionTypes> | undefined) => void,
    sectors:OptionTypes | any , 
    setSectors:(opt: MultiValue<OptionTypes> | undefined) => void,
    cities:OptionTypes | any , 
    setCities:(opt: MultiValue<OptionTypes> | undefined) => void,
    constitutionStatus: OptionTypes | any,
    setConstitutionStatus: (opt: MultiValue<OptionTypes> | undefined) => void,

    //featured
    servicesList: Service[],
    setServiceList: (services:Service[]) => void,
    bannerList:Service[],
    setBannerList: (services:Service[]) => void,
    getBannerList: () => void,
    matchFeaturedService: (serviceId:string) => void,
    
   


}

export type EmailRequest = {email:string , isStartup:boolean}
export type CheckEmailResp = {
    isAvailable:boolean,
    existingGuestUser: User
}

export type ContextProviderProps = {
    children: React.ReactNode;
};


